import React from 'react';

import {
    Modal,
    Form,
    Select,
    Button,
    InputNumber,
    Input,
} from 'antd';

import {
    _postNewPaymentAdvice
} from '../../services';

import SearchInput from './search-input';

const { Option } = Select;

class NewPaymentAdviceModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            entityType: 'user',
            entityId: '',
            amount: 0,
            paymentAdviceNumber: '',

            entityIdList: []
        }
    }


    render() {
        return (
            <Modal
                centered
                onCancel={this.props.closeModal}
                footer={false}
                visible={this.props.visible}
            >
                <h2>Please fill up the Payment Advice details</h2>
                {this.renderForm()}
            </Modal>
        )
    }

    renderForm = () => {

        const { getFieldDecorator } = this.props.form;

        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };

        const tailLayout = {
            wrapperCol: { offset: 20, span: 4 },
        };

        return (
            <Form 
            {...layout}
            onSubmit={this.handleSubmit}>

                <Form.Item
                    style={{ marginTop: '10px' }}
                    name="entityType"
                    label="Entity Type">
                    {getFieldDecorator('entityType', {
                        rules: [{ required: true }],
                    })(
                        <Select
                            placeholder="Select an Entity Type"
                            onChange={this.onEntityTypeChange}
                            allowClear
                        >
                            <Option value="user">User</Option>
                            <Option value="enterprise">Enterprise</Option>
                            <Option value="corpbilling">Corp Billing</Option>
                        </Select>
                    )}
                </Form.Item>

                <Form.Item
                    style={{ marginTop: '10px' }}
                    name="entityId"
                    label="Entity Name">
                    {getFieldDecorator('entityId', {
                        rules: [{ required: true }],
                    })(
                        <SearchInput 
                            placeholder="Select Entity Name"
                            entityType={this.state.entityType}
                            onChange={this.onEntityNameChange}
                            />
                    )}
                </Form.Item>

                <Form.Item label="Amount">
                    {getFieldDecorator('amount', {
                        initialValue: this.state.amount,
                        rules: [{ required: true }],
                    })(
                        <InputNumber id="amount" min={0.00}/>
                    )}
                </Form.Item>

                <Form.Item label="PA Number">
                    {getFieldDecorator('paymentAdviceNumber', {
                        initialValue: this.state.paymentAdviceNumber,
                        rules: [{ required: true }],
                    })(
                        <Input />
                    )}
                </Form.Item>


                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        )

    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
          if (!err) {
            const { amount, paymentAdviceNumber } = values
            const { entityType, entityId } = this.state
            _postNewPaymentAdvice({
                entityType,
                entityId,
                amount,
                paymentAdviceNumber
            })
            .then(_newExperiment => {
                this.props.closeModal()
                this.props.getPaymentAdvice()
                this.props.form.resetFields()
            })
          }

        })

    }

    onEntityTypeChange = (value) => {
        this.setState({
            entityType: value
        })
    };

    onEntityNameChange = (value) => {
        this.setState({
            entityId: value
        })
    };



}

export default Form.create()(NewPaymentAdviceModal)


// WEBPACK FOOTER //
// ./src/components/payment-advice/new-modal.js